export const SET_CAMPAIGNS = "SET_CAMPAIGNS";
